/**
 * Created by pautab on 13/09/2017.
 */
function initBottin(){

    function format(data) {
        return data.text;
    }


    function formatSelection(data) {

            if(data.courriel != '' && data.courriel != null){
                window.location.href = 'mailto:'+data.courriel;
            }

            return '<div class="bottin-select"><i class="ace-icon fa fa-phone"></i><span class="bottin-select-txt">&nbsp;&nbsp;Bottin du personnel&nbsp;</span></div>';
    }

    $('[name=bottin-telephonique]').select2({
        ajax: {
            url: '/gestion-entreprise/bottin-telephonique/',
            dataType: 'json',
            placeholder: 'Search for a repository',
            quietMillis: 500,
            data: function (search_term) {
                return {
                    search_term: search_term, // search term
                    // page: params.page
                };
            },
            results: function (data) {
                // Tranforms the top-level key of the response object from 'items' to 'results'
                return {
                    results: data
                };
            },

        },
        dropdownCssClass : 'bigdrop',
        minimumInputLength: 3,
        initSelection: function (element, callback) {
            // si on met à jour l'élément avec select2('val', ...) depuis formatSelection, alors, il passe ici pour retourner l'information
            callback(element);
        },
        formatResult: format,
        formatSelection: formatSelection
    });
}

initBottin();
